module.exports = __webpack_public_path__ + "img/電気回路_1_10_3.47997d22.png";